import React, { useState } from 'react';
import EventsDataTable from './EventsDataTable.jsx';
import EventForm from './EventForm.jsx';
import EventRegistrations from './EventRegistrations.jsx';
import ReservationVerifier from './ReservationVerifier.jsx';
import QRScanner from './QRScanner.jsx';

function EventsManagement() {
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showRegsFor, setShowRegsFor] = useState(null);
  const [showVerifier, setShowVerifier] = useState(false);
  const [showScanner, setShowScanner] = useState(false);
  const [scannedId, setScannedId] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleScan = (reservationId) => {
    setShowScanner(false);
    setScannedId(reservationId);
    setShowVerifier(true);
  };

  const onCreate = () => { setEditingId(null); setShowForm(true); };
  const onEdit = (id) => { setEditingId(id); setShowForm(true); };
  const onSaved = () => { setShowForm(false); setEditingId(null); setRefreshKey(k => k+1); };

  const onDelete = async (id) => {
    if (!window.confirm('Supprimer cet événement et toutes ses inscriptions ?')) return;
    try {
      const API_BASE = process.env.REACT_APP_BACKEND_URL || '';
      const url = new URL(`/api/admin/events/${id}`, API_BASE);
      const headers = {};
      const token = localStorage.getItem('authToken');
      if (token) headers['Authorization'] = `Bearer ${token}`;
      const res = await fetch(url.toString(), { method: 'DELETE', headers });
      if (!res.ok) throw new Error('Erreur suppression');
      setRefreshKey(k => k+1);
      alert('Événement supprimé');
    } catch (e) { alert(e.message); }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold" style={{ fontFamily: '"Lora", serif', color: 'rgb(196, 150, 96)' }}>Gestion des événements</h1>
        <div className="flex gap-3">
          {!showForm && !showRegsFor && !showVerifier && !showScanner && (
            <>
              <button 
                onClick={() => setShowScanner(true)} 
                className="text-white px-4 py-2 rounded-lg flex items-center gap-2" 
                style={{ backgroundColor: 'rgb(59, 130, 246)' }}
              >
                📷 Scanner QR Code
              </button>
              <button 
                onClick={() => setShowVerifier(true)} 
                className="text-white px-4 py-2 rounded-lg flex items-center gap-2" 
                style={{ backgroundColor: 'rgb(34, 197, 94)' }}
              >
                🔍 Vérifier réservation
              </button>
              <button 
                onClick={onCreate} 
                className="text-white px-4 py-2 rounded-lg" 
                style={{ backgroundColor: 'rgb(196, 150, 96)' }} 
                onMouseEnter={(e) => e.target.style.backgroundColor = 'rgb(176, 130, 76)'} 
                onMouseLeave={(e) => e.target.style.backgroundColor = 'rgb(196, 150, 96)'}
              >
                Nouvel événement
              </button>
            </>
          )}
        </div>
      </div>

      {showScanner && (
        <QRScanner onScan={handleScan} onClose={() => setShowScanner(false)} />
      )}

      {showVerifier && (
        <ReservationVerifier 
          initialReservationId={scannedId}
          onClose={() => {
            setShowVerifier(false);
            setScannedId(null);
          }} 
        />
      )}

      {showForm && (
        <EventForm eventId={editingId} onCancel={() => { setShowForm(false); setEditingId(null); }} onSaved={onSaved} />
      )}

      {showRegsFor && (
        <EventRegistrations eventId={showRegsFor} onClose={() => setShowRegsFor(null)} />
      )}

      {!showForm && !showRegsFor && (
        <EventsDataTable 
          onEdit={(id) => onEdit(id)} 
          onViewRegs={(id) => setShowRegsFor(id)} 
          onDelete={(id) => onDelete(id)} 
          refreshKey={refreshKey}
        />
      )}

      {/* Liste des événements */}
    </div>
  );
}

export default EventsManagement;